export default __webpack_public_path__ + "static/media/cruise-control.62dc8977.svg";